/**
 * Cache management utilities
 */

// Version of the app - increment this to force cache clear
const APP_VERSION = '2.0.0';
const VERSION_KEY = 'app_version';

/**
 * Check if cache should be cleared (new version detected)
 * Call this on app initialization
 */
export const checkAndClearCache = () => {
  const storedVersion = localStorage.getItem(VERSION_KEY);
  
  if (storedVersion !== APP_VERSION) {
    console.log(`🔄 App updated from ${storedVersion || 'unknown'} to ${APP_VERSION}`);
    clearAppCache();
    localStorage.setItem(VERSION_KEY, APP_VERSION);
  }
};

/**
 * Clear all application cache
 */
export const clearAppCache = () => {
  console.log('🧹 Clearing application cache...');
  
  // Clear localStorage except version and auth data
  const token = localStorage.getItem('access_token');
  const user = localStorage.getItem('user');
  
  localStorage.clear();
  
  // Restore auth data
  if (token) localStorage.setItem('access_token', token);
  if (user) localStorage.setItem('user', user);
  
  // Clear sessionStorage
  sessionStorage.clear();
  
  // Unregister service workers
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister());
    });
  }
  
  console.log('✅ Cache cleared successfully');
};

/**
 * Force reload with cache bypass
 */
export const forceReload = () => {
  // Use location.reload(true) for hard reload
  window.location.reload(true);
};

/**
 * Clear cache and reload
 */
export const clearCacheAndReload = () => {
  clearAppCache();
  setTimeout(() => {
    forceReload();
  }, 100);
};
